export default __webpack_public_path__ + "static/media/app-mockup.3cdce84c.png";